// store/modules/user.js
import axios from 'axios';

export default {
    namespaced: true,
    state: {
        users: {},
        currentUser: null,
    },

    mutations: {
        setUsers(state, users) {
            state.users = users;
        },
        setCurrentUser(state, user) {
            state.currentUser = user;
        },
    },

    actions: {
        async fetchUsers({ commit }) {
            try {
              const {data} = await axios.get(`${process.env.VUE_APP_API_HOST}/users`, {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
              });
              commit('setUsers', data.users.reduce((acc, user) => {
                acc[user.id] = user;
                return acc;
              }, {}))
            } catch (error) {
              console.error('Error fetching users:', error);
            }
        },

        async fetchCurrentUser({ commit }) {
            try {
              const {data} = await axios.get(`${process.env.VUE_APP_API_HOST}/users/me`, {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
              });
              commit('setCurrentUser', data.user)
            } catch (error) {
              console.error('Error fetching current user:', error);
            }
        },
    },

    getters: {
        getUsers(state) {
            return state.users;
        },
        getCurrentUser(state) {
          return state.currentUser;
      },
    },
};
